module.exports = __webpack_public_path__ + "img/robot.da58ddde.jpeg";